import { Device } from '../../../../stateManager/store/formCreation_v2/types'

export const LargeDevices: Device[] = [
    {
      name: "Desktop Large",
      resolution: "1920x1080"
    },
    {
      name: "Desktop Standard",
      resolution: "1366x768"
    },
    {
      name: "Desktop Retina",
      resolution: "1440x900"
    },
    {
      name: "Desktop Small",
      resolution: "1280x720"
    }
  ]
  
export const TabletDevices: Device[] = [
    {
      name: "Ipad 9'",
      resolution: "768x1024"
    },
    {
      name: "Ipad 10'",
      resolution: "834x1112"
    },
    {
      name: "Ipad Pro 11'",
      resolution: "834x1194"
    },
    {
      name: "Ipad Pro 12'",
      resolution: "1024x1366"
    }
  ]
  
export const MobileDevices: Device[] = [
    {
      name: "Iphone X",
      resolution: "375x812"
    },
    {
      name: "Iphone SE",
      resolution: "375x667"
    },
    {
      name: "Iphone 13 Pro Max",
      resolution: "428x926"
    },
    {
      name: "Google Pixel 4",
      resolution: "412x732"
    },
    {
      name: "Google Pixel 4XL",
      resolution: "412x869"
    },
    {
      name: "Samsung Galaxy S8",
      resolution: "360x720"
    },
    {
      name: "Samsung Galaxy S20",
      resolution: "360x800"
    },
    {
      name: "Samsung Galaxy S21 Ultra",
      resolution: "412x915"
    }
  ]